export default "__VITE_ASSET__B_4578Fp__"